import supergasbrasFavicon from "assets/supergasbras/icons/favicon.png";
import logoMin from "assets/supergasbras/logos/logoMin.svg";
import logoFull from "assets/supergasbras/logos/logoFull.svg";

import Envrionments from "./enums/envrionments";

const getEnvironmentVariables = () => {
  const clientKey = process.env.REACT_APP_CLIENT_KEY;

  const environmentVariables = {
    [Envrionments.SUPERGASBRAS]: {
      clientName: "Pedir gás",
      faviconImg: supergasbrasFavicon,
      logoMin,
      logoFull,
    },
  };

  return environmentVariables[clientKey as Envrionments];
};

const loadInitialConfig = () => {
  const environmentVariables = getEnvironmentVariables();

  const faviconElm = document.getElementById("favicon") as HTMLLinkElement;
  faviconElm.href = environmentVariables.faviconImg;

  document.title = `Portal da revenda - ${environmentVariables.clientName}`;
};

export { getEnvironmentVariables, loadInitialConfig };
